import useAuth from '@frontend/hooks/useAuth'
import { useGlobalStore } from '@frontend/libs/stores/globalStore'
import { Button } from '@nextui-org/react'
import { __ } from '@wordpress/i18n'
import { Link } from 'react-router-dom'

function SignInButton() {
  const { getProfile, isLoggedIn } = useAuth()
  const { setLoginPopupOpen } = useGlobalStore((state) => state)

  if (isLoggedIn) {
    const { data: user } = getProfile()

    return (
      <Button as={Link} className="text-lg uppercase" to={`/my-account`}>
        {user?.displayName || __('My Account', 'asavagroup')}
      </Button>
    )
  }

  return (
    <Button
      className="text-lg uppercase"
      onPress={() => setLoginPopupOpen(true)}
    >
      {__('Sign In', 'asavagroup')}
    </Button>
  )
}

export default SignInButton
